import { Component, ViewChild } from '@angular/core';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { IWizItemRenderer } from '@wizeoo/akm-component-lib';
import { Observable } from 'rxjs';
import { BaseTileRenderer, VISION_PROPERTY } from '@wizeoo/akm-common-lib';
import { BusinessUnitVO } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';

/**
 * Vignette de présentation d'une entité métier pour l'affichage en mode vignette du MultiDisplay
 */

@Component({
  selector: 'vision-tile-renderer',
  template: `<basetile-renderer #mdBusinessUnitTileRenderer>
    <div target="title">
      <wiz-hgroup width="100%" height="100%" padding="2px" [verticalAlign]="'center'">
      <wiz-icon #icoSettings *ngIf="isConfigApp">settings</wiz-icon>
        <wiz-label [wizLabel]="label" [wizTextBehavior]="'truncate'"></wiz-label>
      </wiz-hgroup> 
      
    </div>
    <div target="complementaryTitle">
    <wiz-hgroup width="100%" height="100%" padding="2px" [verticalAlign]="'center'">
      
      <wiz-image width="24px" height="24px" [sourceObservable]="businessUnit?.iconOrDie" style="align-self: center;"></wiz-image>
      <wiz-label [wizLabel]="businessUnit?.businessUnitCode" [wizTextBehavior]="'truncate'"></wiz-label>
    </wiz-hgroup> 
    </div>
    <div target="body">
      <wiz-hgroup width="100%" height="100%" [verticalAlign]="'center'">
        <wiz-image *ngIf="!isConfigApp" width="25px" height="25px" [sourceObservable]="iconOrDie" style="align-self: center;"></wiz-image>
        <wiz-image #imgRunMode [source]="modeIcon" width="25x" height="25px"></wiz-image> 
 
        <wiz-label #lbDescription [wizLabel]="description" width="100%" height="100%"></wiz-label>
      </wiz-hgroup>
    </div>
  </basetile-renderer>`,
})
export class VisionTileRenderer implements IWizItemRenderer<null, VisionVO> {
  @ViewChild('mdBusinessUnitTileRenderer', { read: BaseTileRenderer, static: true })
  mdTileRenderer: BaseTileRenderer;

  // Le VO manipulé
  private _data: VisionVO;
  public get data(): VisionVO {
    return this._data;
  }
  public set data(data: VisionVO) {
    this._data = data;
    this.mdTileRenderer.data = data;
    this.mdTileRenderer.headerColor = data.color ? data.color+'99' : null;
    this.mdTileRenderer.showComplementaryTitle = true;
    this.mdTileRenderer.showFooter = false;
  }

  public get isConfigApp(): boolean {
    return Model.getInstance().visionEngine.getVisionProperties(this.data, VISION_PROPERTY.ISCONFIGAPP);
  }

  public get modeIcon(): any {
    return Model.getInstance().visionEngine.getVisionProperties(this.data, VISION_PROPERTY.RUN_MODE_ICON);
  }

  public get iconOrDie(): Observable<string> {
    return Model.getInstance().visionEngine.getVisionIconOrDie(this.data);
  }

  public get label(): string {
    return Model.getInstance().visionEngine.getVisionLabel(this.data);
  }

  public get description(): string {
    return Model.getInstance().visionEngine.getVisionDescription(this.data);
  }

  public get businessUnit(): BusinessUnitVO {
    return Model.getInstance().businessUnitEngine.getByBusinessUnitCode(this.data.domain, this.data.businessUnitCode);
  }
}
